import _ from 'lodash';
import mediaQuery from 'css-mediaquery';

function createMatchMedia(width: number) {
  return (query: string): MediaQueryList => ({
    matches: mediaQuery.match(query, { width }) as boolean,
    media: '',
    addListener: () => _.noop,
    removeListener: () => _.noop,
    onchange: () => _.noop,
    addEventListener: () => _.noop,
    removeEventListener: () => _.noop,
    dispatchEvent: _.constant(true),
  });
}

// example: mockMatchMedia(window.innerWidth);
export function mockMatchMedia(width: number) {
  window.matchMedia = createMatchMedia(width);
}
